<template>
  <div class="card">
    <div class="title-container">Centro de ayuda</div>
    <ul class="help-widgets-container">
      <li v-for="(widget, index) of helpWidgets" :key="index" class="help-widget">
        <a :href="widget.url" target="_blank" class="help-widget-link">
          {{ widget.text }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { externalURLS } from '@/router/routes/urlRoutes'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { useAuthStore } from '@/stores/auth/useAuthStore'

const { t } = useI18n()
const text = {
  courses: t('components.dialog.support_service.help_center.courses'),
  frecuentQuestions: t('components.dialog.support_service.help_center.frequent_questions'),
  manuals: t('components.dialog.support_service.help_center.manuals'),
  title: t('components.dialog.support_service.help_center.title'),
  videos: t('components.dialog.support_service.help_center.videos')
}

const authStore = useAuthStore()

const encryptedUserId = computed<string>(() => authStore.encryptedUserId)

const urls = computed(() => {
  const encryptedUserIdValue = encryptedUserId.value
  return {
    courses: `${ externalURLS.courses }${ encryptedUserIdValue }`,
    faqs: `${ externalURLS.faqs }${ encryptedUserIdValue }`,
    helpCenterEmail: externalURLS.help_center_email,
    manuals: `${ externalURLS.manuals }${ encryptedUserIdValue }`,
    helpCenter: `${ externalURLS.help_center }${ encryptedUserIdValue }`,
    videos: `${ externalURLS.videos }${ encryptedUserIdValue }`
  }
})

const helpWidgets = computed(() => {
  return [
    {
      text: text.frecuentQuestions,
      url: urls.value.faqs
    },
    {
      text: text.videos,
      url: urls.value.videos
    },
    {
      text: text.manuals,
      url: urls.value.manuals
    },
    {
      text: text.courses,
      url: urls.value.courses
    }
  ]
})
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  padding: $spacing-sm;
  flex-direction: column;
  align-items: center;
  gap: $spacing-sm;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: $cornerRadius-md;
  background: $main-050;

  .title-container {
    @include milano-bold-24;
    padding: $spacing-xs;
    color: $highlight-200;
    text-align: center;
  }

  .help-widgets-container {
    @include list;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: $spacing-sm;
    width: 100%;

    .help-widget {
      width: 100%;

      .help-widget-link {
        @include milano-medium-18;
        display: flex;
        width: 100%;
        padding: $spacing-lg $spacing-xs;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: $spacing-xxs;
        border-radius: $cornerRadius-md;
        background: $neutral-white-000;
        text-decoration: none;
      }
    }
  }
}
</style>
